<template>
    <section class="author-profile-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12">
                    <aside class="sidebar sidebar_author">

                        <profile-filter v-if="media > 992" :media="media" :filters="filter" :userDataId="userData.id" />

                        <profile-tabs :user="user" v-if="media > 992" />

                    </aside>
                </div>
                <div class="col-lg-8 col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <profile-about-blocks :userData="userData" />
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <profile-about-description :userData="userData"/>
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-filter :media="media"  :filters="filter" :userDataId="userData.id" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <volunteer-actual-pets-component :filter="profilePageList" :user="user"></volunteer-actual-pets-component>
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-tabs :user="user"/>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import ProfileTabs from "./Profile/ProfileTabs";
    import ProfileAboutBlocks from "./Profile/ProfileAboutBlocks";
    import ProfileAboutDescription from "./Profile/ProfileAboutDescription";
    import ProfileFilter from "./Profile/ProfileFilter";
    export default {
        props: ['user'],
        components:{
            ProfileTabs,
            ProfileAboutBlocks,
            ProfileAboutDescription,
            ProfileFilter,
        },
        data() {
            return {
                media: '',
                // petsType: 'actual',
                filter: {
                    params: [
                        {
                            nameValue: 'actual',
                            title: '',
                            checked: true
                        },
                        {
                            nameValue: 'projects',
                            title: '',
                            checked: false
                        },
                        {
                            nameValue: 'past',
                            title: '',
                            checked: false
                        },
                        {
                            nameValue: 'personal',
                            title: '',
                            checked: false
                        }
                    ],
                    value: 'actual'
                },
                appRoute: null,
                base: '',
                url: '',
                chat_url: '',
                formData: {
                    phone: null
                },
            }
        },
        created() {
            this.appRoute = window.appRoute;
            this.base = window.location.origin;
            this.url = this.base + '/getchat/'
            this.chat_url = this.base + '/chat/'


            this.myEventHandler()

            window.addEventListener("resize", this.myEventHandler);
        },
        destroyed(){
            window.removeEventListener("resize", this.myEventHandler);
        },
        mounted() {
            this.localizeFilterTitles()
        },
        computed: {
            translates(){
                return this.$store.getters.translates;
            },
            userData() {
                return this.user ? this.user : this.$store.getters.getUserData;
            },
            profilePageList(){

                let result = {
                    title: '',
                    petsType: '',
                }

                switch (this.filter.value){
                    case "actual":
                        result.petsType = 'actual';
                        result.title = this.$store.getters.t('user_profile_filter_actual_wards');
                        break;
                    case "projects":
                        result.petsType = 'projects';
                        result.title = this.$store.getters.t('user_profile_filter_projects');
                        break;
                    case "past":
                        result.petsType = 'past';
                        result.title = this.$store.getters.t('user_profile_filter_past_wards');
                        break;
                    case "personal":
                        result.petsType = 'personal';
                        result.title = this.$store.getters.t('user_profile_filter_personal_pets');
                        break;
                }

                return result

            },
        },
        methods: {

            myEventHandler(e){
                this.media = window.innerWidth
            },

            localizeFilterTitles(){
                const map = {
                    actual: 'user_profile_filter_actual_wards',
                    projects: 'user_profile_filter_projects',
                    past: 'user_profile_filter_past_wards',
                    personal: 'user_profile_filter_personal_pets'
                }

                this.filter.params = this.filter.params.map(p => ({
                    ...p,
                    title: this.$store.getters.t(map[p.nameValue])
                }))
            },

            getChat(id){
            axios.get(this.url+id, {
                }
            ).then(response=>{
                this.$store.commit('get_messages',response.data.data.message)
                this.$store.commit('get_receiver_id',id)
                this.$store.commit('get_current_user',response.data.data.user)
                window.location.href=this.chat_url
            })
              },

        },

    }
</script>

<style lang="scss" scoped>

@import '../../sass/helpers';

.author-btn a{
    font-size: 12px;
}
.total-info{
    font-size: 15px;
}

.author-info p {
    margin-bottom: 12px;
}

</style>
